import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export interface SessionEndConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SessionEndConfirmDialog: React.FC<SessionEndConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>セッションを終了しますか？</DialogTitle>
    <DialogContent>
      <DialogContentText>
        セッションを終了すると、AIによる評価が生成され、結果ページに移動します。
        この操作は取り消せません。
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>キャンセル</Button>
      <Button onClick={onConfirm} color="primary" variant="contained">
        終了する
      </Button>
    </DialogActions>
  </Dialog>
);
